import React, { useEffect, useState } from "react";
import { CalendarDays, Clock } from "lucide-react";
import { api } from "@/lib/api";

const fmtCountdown = (s) => {
  if (s <= 0) return "Drawing now";
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${String(sec).padStart(2, "0")}s`;
};

export function DrawSchedule() {
  const [sched, setSched] = useState(null);
  const [tick, setTick] = useState(0);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    api.get("/draws/schedule?count=12").then((r) => setSched(r.data));
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);

  if (!sched) return null;
  const next = sched.upcoming[0];
  const secs = next ? Math.max(0, Math.floor((new Date(next.draw_time_iso) - Date.now()) / 1000)) : 0;

  return (
    <section id="schedule" data-testid="draw-schedule" className="px-4 sm:px-8 lg:px-12 py-8 max-w-[1400px] mx-auto">
      <div className="bg-surface border border-white/5 rounded-xl p-6 sm:p-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div>
            <div className="label-caps text-oracle flex items-center gap-2"><CalendarDays className="w-3 h-3" strokeWidth={1.5} /> Draw Schedule</div>
            <h2 className="font-heading text-3xl sm:text-4xl mt-1 tracking-tight text-parchment">
              Every <span className="italic text-oracle">Monday · Wednesday · Saturday</span>
            </h2>
            <div className="font-body text-parchment/60 text-sm mt-2 flex items-center gap-2" data-testid="draw-time">
              <Clock className="w-3.5 h-3.5" strokeWidth={1.5} /> {sched.draw_time} · Sales cut-off varies by state
            </div>
          </div>
          {next && (
            <div className="text-left lg:text-right">
              <div className="label-caps">Next drawing in</div>
              <div data-testid="next-draw-countdown" className="font-heading text-4xl text-oracle tracking-tight tabular-nums">{fmtCountdown(secs)}</div>
              <div className="font-body text-parchment/60 text-xs mt-1" data-testid="next-draw-date">{next.label}</div>
            </div>
          )}
        </div>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {sched.upcoming.map((u, i) => (
            <div
              key={u.date}
              data-testid={`upcoming-draw-${u.date}`}
              className={`rounded-lg border px-4 py-3 transition-colors ${i >= 6 && !showAll ? "hidden sm:block" : ""} ${i === 0 ? "border-oracle/40 bg-oracle/5" : "border-white/5 bg-black/20 hover:border-white/15"}`}
            >
              <div className={`label-caps ${i === 0 ? "text-oracle" : "text-parchment/50"}`}>{u.weekday}</div>
              <div className="font-heading text-xl text-parchment mt-1">{u.label.split(", ").slice(1, 2)[0]}</div>
              <div className="font-body text-[11px] text-parchment/40 mt-0.5">{u.date.slice(0, 4)}</div>
            </div>
          ))}
        </div>
        {sched.upcoming.length > 6 && (
          <button data-testid="schedule-toggle-btn" onClick={() => setShowAll((s) => !s)} className="sm:hidden mt-4 w-full label-caps text-oracle py-2.5 border border-white/10 rounded-md hover:border-oracle/40 transition-colors">
            {showAll ? "Show fewer" : `Show all ${sched.upcoming.length} upcoming draws`}
          </button>
        )}
      </div>
    </section>
  );
}
